import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AppSolicitudesBolsa } from '../models/appSolicitidesBolsa.model';
import { IServiceBase } from './base/IServiceBase';
import { PageList } from '../models/pageList.model';
import { AppConfig } from '../configuration/app.config';


//usuarios copy ARREGLAR (son los métodos de get y set)

@Injectable()
export class AppSolicitudesBolsaService extends HttpClientBaseService implements IServiceBase<AppSolicitudesBolsa> {

  constructor(_http: HttpClient) {
    super(_http, '/requests/', '', false);

  }
  getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<AppSolicitudesBolsa>> {
    throw new Error('Method not implemented.');
  }

  /*   getAllModels(): Observable<AppSolicitudes[]> {
      return super.getAll<AppSolicitudes[]>();
    } */


    getAllModels(): Observable<AppSolicitudesBolsa[]> {
      // Datos estáticos
  
      //quitar el rol de usuario
      const url = `${AppConfig.settings.apiServerPE.apiUrl}holidaybag`;
  
      // Crear los headers con la clave API
      const headers = new HttpHeaders({
        'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
      });
  
  
      return this.http.get<AppSolicitudesBolsa[]>(url, { headers: headers });
    }







  getModel(id: any): Observable<AppSolicitudesBolsa> {
    return super.getSingle<AppSolicitudesBolsa>(id);
  }



  public updateModel(id: string, data: Partial<AppSolicitudesBolsa>): Observable<AppSolicitudesBolsa> {
    const url = `${AppConfig.settings.apiServerPE.apiUrl}holidaybag/${id}`;
    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });



    // Realizar la petición PATCH y devolver el resultado como un Observable
    return this.http.patch<AppSolicitudesBolsa>(url, data, { headers: headers });
  }
 
}